<template>
  <div class="global-footer">
    <a >{{ Config.footerTxt }}</a>
    <div />
  </div>
</template>

<script>
import Config from "@/config"

export default {
  name: "GlobalFooter",
  data () {
    return {
      Config
    }
  }
}
</script>

<style scoped>
.global-footer {
  font-size: 12px;
  text-align: center;
  color: #606266;
}

a {
  margin: 5% 0;
}
</style>
